<div class="flex flex-col">

  <div *ngIf="communicationLog.id === 0" [@slideRight]>
    <mat-table [dataSource]="logSource" matSort #logSort="matSort" aria-describedby="communications log" class="mat-elevation-z8 portal-responsive-table">
      <ng-container matColumnDef="sentDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Date Sent</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let log">
          <span class="mobile-label">Date Sent</span>
          {{ log.sentDate | date: 'short' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="subject">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Subject</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let log">
          <span class="mobile-label">Subject</span>
          {{ log.subject }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="recipients">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Recipients</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let log">
          <span class="mobile-label">Recipients</span>
          {{ log.recipients }}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="logColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: logColumns" class="" (click)="selectLog(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectLog(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectLog(row))"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[10, 25, 50]" #logPaginator="matPaginator">
    </mat-paginator>
  </div>

  <div class="flex-flex-col gap-4" *ngIf="communicationLog.id !== 0" [@slideRight]>
    <div class="flex flex-col md:flex-row md:gap-4">
      <span>{{ communicationLog.sentDate | date: 'short' }}</span>
      <span>{{ communicationLog.subject }}</span>
      <span>{{ communicationLog.recipients }}</span>
    </div>

    <span>{{ communicationLog.body }}</span>

    <div class="flex flex-row portal-actions">
      <button class="ml-auto" mat-button type="button" color="primary" (click)="closeLog()">Close</button>
    </div>
  </div>

</div>
